// Must import the following types, otherwise we get a TS2742: The inferred type cannot be named without a reference to X. This is likely not portable.
// A type annotation is necessary.

import {
    type EventBus as FireflyEventBus,
    useEventBus as useFireflyEventBus,
    useEventBusDispatcher as useFireflyEventBusDispatcher,
    useEventBusListener as useFireflyEventBusListener
} from "@squide/firefly";

// This gives autocomplete for known events, but allows any string event as well
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type AllEvents = keyof EventMap | (string & {});

// The "EventMap" interface is expected to be extended by the consumer packages.
// This magic is called module augmentation: https://www.typescriptlang.org/docs/handbook/declaration-merging.html#module-augmentation.
export interface EventMap {}

export type EventBusPayload<T> = T extends keyof EventMap ? EventMap[T] : unknown;

type EventBusCallback<T> = T extends keyof EventMap ? (data: EventMap[T]) => void : (data?: unknown) => void;

export type EventBus = FireflyEventBus;

export function useEventBus() {
    return useFireflyEventBus();
}

type EventBusDispatchArgs<T extends AllEvents> = T extends keyof EventMap
    ? [event: T, payload: EventMap[T]]
    : [event: T, payload?: unknown];

export type EventBusDispatcher = <T extends AllEvents>(...args: EventBusDispatchArgs<T>) => void;

export const useEventBusDispatcher = useFireflyEventBusDispatcher as () => EventBusDispatcher;
export const useEventBusListener = useFireflyEventBusListener as <T extends AllEvents>(
    event: T,
    callback: EventBusCallback<T>,
    options?: { once?: boolean }
) => void;
